// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert__Alert___1w_b5","Text":"Alert__Text___1PNkC"};